<template>
  <div class="add-port-panel">
    <div
      v-for="(item, index) in portList"
      :key="item?.key || index"
      class="grid grid-cols-[1fr,1fr,80px] gap-x-2"
    >
      <Input
        :id="`rde-input-port-name-${index}`"
        v-model="item.name"
        :placeholder="
          $t('workspace_rde.rde_detail.placeholder.enter_port_name')
        "
        :rules="[rules.required, rules.name, validateDuplicate('name')]"
        :label="`* ${$t('workspace_rde.rde_detail.label.port_name')}`"
        appendClass="input-text-field-v2 text-details"
      />
      <NumberInput
        :id="`rde-input-port-value-${index}`"
        v-model="item.port"
        format="none"
        :placeholder="$t('workspace_rde.rde_detail.placeholder.port_number')"
        :rules="[rules.required, validatePort, validateDuplicate('port')]"
        :label="`* ${$t('workspace_rde.rde_detail.label.port')}`"
        appendClass="input-text-field-v2 text-details"
        :max="65535"
        :min="0"
      />
      <div class="flex w-3">
        <v-icon
          v-show="portList.length > 1"
          class="h-6 mt-1"
          @click="handleRemoveClick(index)"
        >
          mdi-close
        </v-icon>
      </div>
    </div>
    <div v-if="!portList.length" class="text-xs text-error h-5">
      {{ $t("workspace_rde.rde_detail.message.require_port") }}
    </div>
    <Button class="add-button" size="md" @click="handleAddClick">
      <v-icon>mdi-plus</v-icon>
      {{ $t("workspace_rde.rde_detail.button.add_port") }}
    </Button>
  </div>
</template>

<script>
import Button from "@/components/atoms/Button/Button.vue";
import Input from "@/components/atoms/Input/Input.vue";
import NumberInput from "@/components/atoms/NumberInput/NumberInput.vue";
import { RulesMixin } from "@/mixins/RulesMixin";

export default {
  props: {
    portList: {
      type: Array,
      default: () => [],
    },
  },
  components: { Input, Button, NumberInput },
  mixins: [RulesMixin],
  emits: ["change"],
  methods: {
    validateDuplicate(name) {
      return (value) =>
        value &&
        this.portList &&
        this.portList?.filter((i) => i?.[name] === value)?.length > 1
          ? `${name.charAt(0).toUpperCase() + name.slice(1)} ${this.$t(
              "workspace_rde.rde_detail.rule_message.duplicate_port",
            )}`
          : true;
    },
    validatePort(value) {
      if (value && [8443, 3000, 2222, 3333, 9931].includes(Number(value))) {
        return this.$t(
          "workspace_rde.rde_detail.rule_message.restricted_ports",
        );
      }
      return true;
    },
    handleAddClick() {
      const newDefaultPort = this.portList?.length
        ? Math.max(...this.portList.map((i) => i.port)) + 1
        : 8080;

      const newItems = [
        {
          key: Math.random(),
          name: "",
          protocol: "TCP",
          port: newDefaultPort,
          targetPort: newDefaultPort,
        },
        ...this.portList,
      ];
      this.$emit("change", newItems);
    },
    handleRemoveClick(index) {
      const newItems = this.portList.filter((_, i) => i !== index);
      this.$emit("change", newItems);
    },
  },
};
</script>

<style lang="scss">
.add-port-panel {
  padding: unset;
  margin: unset;
  margin-top: 10px;
  border: none;
  .add-button {
    border: none;
    background: #f5f5f5;
    font-size: 12px;
    font-weight: 700;
  }

  .text-details {
    .v-text-field__details {
      min-height: 14px !important;
    }
  }
}
</style>
